import { z } from "zod";
import type { infer as zInfer } from "zod";
import { timestamp } from "@/hooks/firestore/models/timestamp";
import { automationComponent } from "./baseAutomation";

export const tokenAllocation = z.object({
  automationId: z.string(),
  createdAt: timestamp,
  expiresAt: timestamp,
  markedForDeletion: z.boolean().optional(),
  attributes: z.record(z.string(), z.any()).nullish(),
  actions: z.array(automationComponent).nullish(),
  priorityAscending: z.number().nullish(),
  completeBetSlipInfo: z.record(z.string(), z.string()).nullish(),
});

export type TokenAllocation = zInfer<typeof tokenAllocation>;
